import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output, AfterViewChecked } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

export interface EditColumn {
    nomeColonna: string;
    idColonna: string;
    percentWidth?: number;
    dataType?: any;
    alignment?: 'right' | 'left' | 'center';
}

export interface EditRowAction {
    action: string;
    element?: any;
}

@Component({
    selector: 'fb-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit, AfterViewChecked {
    public tableDataSource = new MatTableDataSource([]);
    public displayedColumns: string[];
    @Input() showAddButton: boolean = true;
    @Input() editColumns: EditColumn[];
    @Input() rowActionIcons: string[];

    @Output() rowAction: EventEmitter<EditRowAction> = new EventEmitter<EditRowAction>();

    deleteButtonIsDisabled: boolean;

    @Input() set dataSource(data: any[]) {
        this.setTableDataSource(data);
    }

    constructor(@Inject(DOCUMENT) private document: Document) {}

    ngOnInit(): void {
        this.displayedColumns = this.editColumns.map((atecoEditColumn: EditColumn) => atecoEditColumn.nomeColonna);
    }

    setTableDataSource(data: any) {
        this.tableDataSource = new MatTableDataSource<any>(data);
    }

    editMaterialColumnWidth() {
        const displayedColumnsSanitizeForMatColumn = this.editColumns.map(atecoEditColumn => {
            return { nomeColonnaSantize: atecoEditColumn.nomeColonna.trim().replace(/\s+/g, '-'), percentWidth: atecoEditColumn.percentWidth };
        });
        displayedColumnsSanitizeForMatColumn.map(displayedColumnSanitize => {
            const classMatColumnToEdit = `mat-column-${displayedColumnSanitize.nomeColonnaSantize}`;
            const matColumnsToEdit = <HTMLCollectionOf<HTMLElement>>this.document.getElementsByClassName(classMatColumnToEdit);

            for (var matColumnToEdit of matColumnsToEdit) {
                if (displayedColumnSanitize.percentWidth) matColumnToEdit.style.width = `${displayedColumnSanitize.percentWidth}%`;
            }
        });
    }

    isButtonDisabled(disabled: boolean) {
        this.deleteButtonIsDisabled = disabled;
        return this.deleteButtonIsDisabled;
    }

    emitRowAction(atecoRow: EditRowAction) {
        this.rowAction.emit(atecoRow);
    }

    ngAfterViewChecked(): void {
        this.editMaterialColumnWidth();
    }
}
